/**
 * Share Vuex
 */
import Cons from '@/constants.json';
import * as API from '@/endpoints'
import Axios from 'axios'
import Vue from 'vue'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    prescription: _.cloneDeep(Cons[0].PRESCRIPTION),
    showSuccess: false,
    showInvite: false,
    groupInvite: false,
    groupInviteId: ""
  },
  getters: {
    isGroupInvite(state) {
      return state.groupInvite
    },
    groupInviteId(state){
      return state.groupInviteId
    }
  },
  mutations: {
    setIsGroupInvite(state, v) {
      state.groupInvite = v
    },
    setGroupInviteId(state, v) {
      state.groupInviteId = v
    },
    resetFields(state) {
      Vue.set(state, 'prescription', _.cloneDeep(Cons[0].PRESCRIPTION))
    },
    setShowSuccess(state, v) {
      Vue.set(state, 'showSuccess', v)
    },
    setShareUrl(state, v) {
      Vue.set(state, 'shareUrl', v)
    },
    setShowInvite(state, v) {
      Vue.set(state, 'showInvite', v)
      if (!v){
        Vue.set(state, 'groupInvite', false)
        Vue.set(state, 'groupInviteId', "")
      }
    }
  },
  actions: {
    getBrand({ commit, dispatch }, { brandId }) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.brand + '/' + brandId)
          .then(res => {
            resolve(res.data)
          }, error => {
            reject(error)
          })
      })
    },
    getBrandShareInfo({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.preview + '/brand/' + payload.brand_id + '?inviter_id=' + payload.user_id).then(res => {
          commit('setShareUrl', res.data)
          resolve(res.data)
        }, error => {
          dispatch('exceptionHandling', { _err: error }, { root: 1 })
          reject(error)
          commit('base/setLoadingPage', false, { root: 1 })
        })
      })
    },
    sharePrescription({ commit, dispatch, state }, { prescription }) {
      return new Promise((resolve, reject) => {
        commit('base/setLoadingPage', true, { root: 1 })
        Axios.post(API.endpoints.prescription, prescription)
          .then(res => {
            commit('resetFields');
            commit('base/setLoadingPage', false, { root: 1 })
            resolve(res.data)
          }, error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
            commit('base/setLoadingPage', false, { root: 1 })
          })
      })
    },
    shareGroup({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('base/setLoadingPage', true, { root: 1 })
        Axios.post(API.endpoints.careplan + "/prescribe", payload)
          .then(res => {
            resolve(res.data)
          }, error => {
            reject(error)
          })
          .finally(() => {
            commit('base/setLoadingPage', false, { root: 1 })
          })
      })
    }
  }
}
